import { ajaxCall } from "@/shared/connection/ajax-call";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";
import { makeLogger } from "@/shared/consola";

const logger = makeLogger("pageOnboardingService");

const ENDPOINT = "/pages";

const EVENTS = {
    GENERATED: "page-generated",
    GENERATION_ERROR: "page-generation-error",
};

export const pageOnboardingService = {
    EVENTS,
    sendOnboardData({
        mode,
        productDetails,
        promptDescription,
        lang,
        pageTemplate,
        pageId,
        pageUuid,
    }) {
        return ajaxCall
            .post(`${ENDPOINT}/onboarding`, {
                mode,
                productDetails,
                promptDescription,
                lang,
                pageTemplate,
                pageId,
                pageUuid,
            })
            .catch(handleErrorByMessage());
    },
    listenEventsFor(pageUUID, subscriber) {
        const evtSource = new EventSource(
            `${process.env.VUE_APP_ORIGIN}/api${ENDPOINT}/events/${pageUUID}`,
            {
                withCredentials: true,
            }
        );
        const mapJSON = (e) => {
            logger.trace("Original event", e);
            subscriber({
                type: e.type,
                payload: JSON.parse(e.data),
            });
        };
        evtSource.addEventListener(EVENTS.GENERATED, mapJSON);
        evtSource.addEventListener(EVENTS.GENERATION_ERROR, mapJSON);
        return evtSource;
    },
};
